import { render } from "./Formvertical.vue?vue&type=template&id=68d070ac"
import script from "./Formvertical.vue?vue&type=script&lang=js"
export * from "./Formvertical.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__